import axios from "axios";

export default {
	computed: {
		valoreProporzionale() {
			if (!this.mxChartConfig.tipologyData) {
				return "";
			}
			return this.mxChartConfig.tipologyData !== "%" ? this.aggregateData(this.mxChartConfig.totalField, this.mxChartConfig.totalFieldAgg) : "";
		},
		secondaryColor() {
			switch (this.mxChartConfig.secondaryValueType) {
				case "T":
					return this.mxChartConfig.aggregationResult >= this.mxChartConfig.referenceValue ? "text-danger" : "text-success";
				default:
					return "text-primary";
			}
		},
		secondaryValue() {
			switch (this.mxChartConfig.secondaryValueType) {
				case "%":
					if (this.valoreProporzionale && this.valoreProporzionale != 0) {
						const formatter = new Intl.NumberFormat("it-IT", {
							style: "percent",
							minimumFractionDigits: 2, // Quanti decimali vuoi dopo la virgola
							maximumFractionDigits: 2,
						});
						return formatter.format(this.mxChartConfig.aggregationResult / this.valoreProporzionale);
					}
					return "";
				case "T":
					return this.mxChartConfig.referenceValue ? "Target < " + this.mxChartConfig.referenceValue : "";
				default:
					return "";
			}
		},
	},
	data() {
		return {
			mxChartConfig: { idQuery: null, principalAgg: null, icon: null, colorIconClass: null, aggregationResult: 0, tipologyData: null, secondaryLabel: null },
			testData: [],
			pathResourceData: "/dataanalysisdatabaseinfo/eseguigraphicquery",
			secondaryIconVisible: false,
			secondaryIcon: "fas fa-info",
		};
	},
	watch: {
		// Se la config esterna cambia (es. reset), aggiorniamo il locale
		// config: {
		// 	handler(newVal) {
		// 		console.log("Questo accade");
		// 		this.mxChartConfig = JSON.parse(JSON.stringify(newVal));
		// 	},
		// 	deep: true,
		// },
		mxChartConfig: {
			handler() {
				this.setSecondaryIcon();
			},
			deep: true,
		},
	},
	methods: {
		setMxChartConfig(chartConfig) {
			this.mxChartConfig = chartConfig;
		},
		setSecondaryIcon() {
			let localIcon = "";
			if (this.mxChartConfig.secondaryValueType === "T") {
				this.secondaryIconVisible = true;
				this.mxChartConfig.secondaryLabel = "";
				localIcon = this.mxChartConfig.aggregationResult >= this.mxChartConfig.referenceValue ? "fas fa-exclamation-triangle" : "fas fa-check";
			} else {
				this.secondaryIconVisible = this.mxChartConfig.secondaryLabel ? true : false;
				localIcon = this.mxChartConfig.secondaryLabel ? "fas fa-info" : "";
			}

			if (localIcon !== this.secondaryIcon) {
				this.secondaryIcon = localIcon;
				this.iconKey++;
			}
		},
		queryLoadData() {
			this.loadWidgetData();
		},
		loadWidgetData() {
			let me = this;
			if (!this.mxChartConfig.idQuery) {
				this.showOverlay = false;
				return;
			}
			this.isExecuting = true;
			let link = process.env.VUE_APP_PATH_API + me.pathResourceData + "/" + this.mxChartConfig.idQuery;
			axios.get(link)
				.then((response) => {
					this.testData = [];
					//this.testData = response.data.data;
					this.testData = response.data.data;
					//console.log(JSON.stringify(this.testData));
					this.isExecuting = false;
					this.showOverlay = false;
					if (this.testData.length === 0) {
						this.$bvToast.toast("La query è stata eseguita ma non ha restituito risultati.", { variant: "warning" });
					}
					this.aggregateData();
				})
				.catch((e) => {
					console.log(e);
				});
		},
		aggregateData() {
			let fieldName = this.mxChartConfig.principalField;
			let aggType = this.mxChartConfig.principalAgg;
			if (!this.testData || !Array.isArray(this.testData) || !aggType) return [];
			const data = this.testData;
			let finalValue = 0;
			// 2. Trasformazione nel formato ECharts { name, value }
			switch (aggType.toLowerCase()) {
				case "count":
					finalValue = data.length; // Numero di record nel gruppo
					break;
				case "min":
					finalValue = data.reduce((max, obj) => (obj[fieldName] < max[fieldName] ? obj : max));
					break;
				case "max":
					finalValue = data.reduce((max, obj) => (obj[fieldName] > max[fieldName] ? obj : max));
					break;
				case "avg":
					finalValue = data.reduce((acc, obj) => acc + obj[fieldName], 0) / data.length;
					break;
				case "sum":
				default:
					finalValue = data.reduce((accumulatore, oggettoCorrente) => {
						return accumulatore + oggettoCorrente[fieldName];
					}, 0);
					break;
			}
			this.mxChartConfig.aggregationResult = finalValue;
			//return finalValue;
		},
	},
};
